import { render, staticRenderFns } from "./BlockSummary.vue?vue&type=template&id=47c0ea12&"
import script from "./BlockSummary.vue?vue&type=script&lang=js&"
export * from "./BlockSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports